import { render } from "./DialogNode.vue?vue&type=template&id=3005cb9a&scoped=true&lang=pug"
import script from "./DialogNode.vue?vue&type=script&lang=js"
export * from "./DialogNode.vue?vue&type=script&lang=js"

import "./DialogNode.vue?vue&type=style&index=0&id=3005cb9a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3005cb9a"]])

export default __exports__